import React from 'react';
import Section from '../Section';
import WorkingProcess from '../Section/WorkingProcess';
import BannerSectionStyle4 from '../Section/BannerSection/BannerSectionStyle4';
import { pageTitle } from '../../helpers/PageTitle';

const riskData = [
  {
    index: '01',
    title: 'Stress',
    text: 'Charge mentale, deadlines, nuits trop courtes : le cœur encaisse en silence.',
  },
  {
    index: '02',
    title: 'Sédentarité',
    text: 'Réunions, transports, écrans. Le corps bouge trop peu, le risque monte.',
  },
  {
    index: '03',
    title: 'Hypertension',
    text: 'Souvent indolore. Trop souvent découverte trop tard.',
  },
  {
    index: '04',
    title: 'Habitudes de vie',
    text: 'Alimentation, tabac, sommeil : des leviers encore actionnables.',
  },
];

const examData = [
  {
    title: 'ECG',
    subTitle: 'Activité électrique du cœur, en quelques minutes.',
    iconUrl: '/images/home_1/exam_ecg.svg',
  },
  {
    title: 'Holter ECG',
    subTitle: 'Surveillance continue du rythme, 24 à 48 heures.',
    iconUrl: '/images/home_1/exam_holter_ecg.svg',
  },
  {
    title: 'Holter tensionnel (MAPA)',
    subTitle: 'Mesure de la tension artérielle pendant 24 heures.',
    iconUrl: '/images/home_1/exam_mapa.svg',
  },
  {
    title: 'Épreuve d’effort',
    subTitle: 'Le cœur à l’effort, sous surveillance médicale.',
    iconUrl: '/images/home_1/exam_effort.svg',
  },
  {
    title: 'Polygraphie ventilatoire',
    subTitle: 'Dépistage de l’apnée du sommeil.',
    iconUrl: '/images/home_1/exam_polygraphie.svg',
  },
  {
    title: 'Échographie cardiaque',
    subTitle: 'Structure et fonction du cœur, en imagerie non invasive.',
    iconUrl: '/images/home_1/exam_echo.svg',
  },
];

const processData = [
  {
    number: '01',
    title: 'En amont',
    subTitle:
      'Une ordonnance de prise de sang est adressée aux participants. Les résultats seront lus par le cardiologue le jour du bilan.',
    iconUrl: '/images/home_1/compassion.svg',
  },
  {
    number: '02',
    title: 'Jour J',
    subTitle:
      'Une journée de soins et d’examens, entièrement adaptable à votre entreprise, pour sensibiliser et dépister.',
    iconUrl: '/images/home_1/excellence.svg',
  },
  {
    number: '03',
    title: 'Restitution',
    subTitle:
      'Chaque collaborateur reçoit un accompagnement détaillé : résultats, lecture médicale, recommandations personnalisées.',
    iconUrl: '/images/home_1/integrity.svg',
  },
  {
    number: '04',
    title: 'Dans la durée',
    subTitle:
      'Le suivi ne s’arrête pas au bilan. Le Dr El Issa reste joignable pour un avis, une consultation ou un accompagnement complémentaire.',
    iconUrl: '/images/home_1/teamwork.svg',
  },
];

export default function CorporateCheckup() {
  pageTitle('Bilan cardiaque d’entreprise');
  return (
    <>
      <section className="cs_corporate_hero">
        <div
          className="cs_corporate_hero_bg cs_bg_filed"
          style={{ backgroundImage: 'url(/images/home_1/hero_bg.jpeg)' }}
        />
        <div className="container">
          <div className="cs_corporate_hero_grid">
            <div>
              <p className="cs_corporate_kicker">Santé au travail · ICVT Paris</p>
              <h1 className="cs_corporate_hero_title">
                Bilan cardiaque
                <br />
                d’entreprise
              </h1>
              <p className="cs_corporate_hero_lead">
                Et si vous faisiez de la prévention cardiovasculaire un véritable
                atout pour la santé et le bien-être de vos collaborateurs ?
              </p>
              <a href="#echanger" className="cs_btn cs_style_1">
                <span>Étudier votre journée</span>
                <i>
                  <img src="/images/icons/arrow_white.svg" alt="" />
                  <img src="/images/icons/arrow_white.svg" alt="" />
                </i>
              </a>
            </div>
            <aside className="cs_corporate_quote">
              <span className="cs_corporate_quote_mark" aria-hidden="true">
                “
              </span>
              <p>
                Les maladies cardiovasculaires figurent parmi les premières
                causes de décès et évoluent souvent sans symptôme.
              </p>
              <small>Institut Cardiovasculaire Trocadéro</small>
            </aside>
          </div>
        </div>
      </section>

      <Section topMd={140} topLg={100} topXl={80} bottomMd={80}>
        <div className="container">
          <div className="cs_section_heading cs_style_1 text-center">
            <h3 className="cs_section_subtitle text-uppercase cs_accent_color cs_semibold m-0 cs_fs_20">
              Le quotidien professionnel
            </h3>
            <div className="cs_height_10" />
            <h2 className="cs_section_title cs_fs_72 m-0">
              Des risques déjà là,
              <br />
              trop souvent invisibles
            </h2>
          </div>
          <div className="cs_height_70 cs_height_lg_40" />
          <p className="cs_corporate_intro">
            Stress, sédentarité, hypertension ou encore mauvaises habitudes de
            vie sont autant de facteurs de risque présents dans le quotidien
            professionnel.
          </p>
          <div className="cs_corporate_risks">
            {riskData.map((item) => (
              <article key={item.index} className="cs_corporate_risk">
                <span>{item.index}</span>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </article>
            ))}
          </div>
        </div>
      </Section>

      <Section bottomMd={80}>
        <div className="container">
          <div className="cs_corporate_offer">
            <div className="cs_corporate_offer_media">
              <img
                src="/images/about/entreprise.png"
                alt="Dr El Issa, cardiologue à l’ICVT"
              />
            </div>
            <div className="cs_corporate_offer_body">
              <p className="cs_corporate_kicker">Journée de prévention</p>
              <h2 className="cs_fs_48 cs_semibold">
                Une journée de soins, entièrement adaptable
              </h2>
              <p>
                Afin d’accompagner les entreprises dans leur démarche de
                prévention, notre cabinet de cardiologie Institut
                Cardiovasculaire Trocadéro ICVT propose l’organisation d’une
                Journée de soins et d’examens médicaux entièrement adaptable à
                vos besoins, conçue pour sensibiliser les collaborateurs et
                favoriser le dépistage précoce des facteurs de risque.
              </p>
            </div>
          </div>
        </div>
      </Section>

      <Section
        topMd={40}
        bottomMd={80}
        className="cs_corporate_exams_band"
      >
        <div className="container">
          <div className="cs_section_heading cs_style_1">
            <h3 className="cs_section_subtitle text-uppercase cs_accent_color cs_semibold m-0 cs_fs_20">
              Plateau technique
            </h3>
            <div className="cs_height_10" />
            <h2 className="cs_section_title cs_fs_48 m-0">
              Un bilan composé selon vos besoins
            </h2>
            <p className="cs_corporate_intro cs_corporate_intro_left">
              Selon les besoins identifiés, les participants peuvent bénéficier
              d’un bilan comprenant différents examens réalisés par notre équipe
              médicale :
            </p>
          </div>
          <div className="cs_corporate_exams">
            {examData.map((item) => (
              <article key={item.title} className="cs_corporate_exam">
                <img src={item.iconUrl} alt="" />
                <h3>{item.title}</h3>
                <p>{item.subTitle}</p>
              </article>
            ))}
          </div>
        </div>
      </Section>

      <Section bottomMd={40}>
        <div className="container">
          <div className="cs_corporate_lab">
            <div className="cs_corporate_lab_stamp">J − 7</div>
            <div>
              <h2 className="cs_fs_32 cs_semibold mb-3">
                Une prise de sang, avant le jour J
              </h2>
              <p className="mb-0">
                Afin d’optimiser cette journée de prévention, une ordonnance de
                prise de sang est adressée en amont aux participants. Les
                résultats sont analysés par le cardiologue lors du bilan,
                permettant une évaluation cardiovasculaire encore plus complète
                et personnalisée.
              </p>
            </div>
          </div>
        </div>
      </Section>

      <Section topMd={80} bottomMd={40}>
        <WorkingProcess
          sectionTitle="Du premier contact au suivi"
          sectionTitleUp="Parcours collaborateur"
          data={processData}
        />
      </Section>

      <Section topMd={40} bottomMd={80}>
        <div className="container">
          <div className="cs_corporate_follow">
            <div>
              <p className="cs_corporate_kicker">Accompagnement</p>
              <h2 className="cs_fs_48 cs_semibold">
                Un suivi personnalisé, bien au-delà du bilan
              </h2>
              <p>
                Chaque collaborateur bénéficie d’un accompagnement personnalisé
                et détaillé, depuis la préparation du bilan jusqu’à la
                restitution des résultats et des recommandations médicales, afin
                d’assurer un suivi de qualité à chaque étape.
              </p>
              <p>
                Au-delà de cette journée de prévention, le suivi se poursuit
                dans la durée. Les collaborateurs peuvent reprendre contact avec
                le Dr El Issa à tout moment pour toute question, un avis
                médical, une consultation de suivi ou un accompagnement
                complémentaire si leur situation le nécessite. Notre objectif
                est d’assurer une prise en charge continue, personnalisée et de
                qualité, bien au-delà du bilan initial.
              </p>
            </div>
            <figure className="cs_corporate_follow_card">
              <img
                src="/images/about/docteur-issa.png"
                alt="Dr El Issa Meidi"
              />
              <figcaption>
                <strong>Dr El Issa Meidi</strong>
                <span>Cardiologue · ICVT</span>
              </figcaption>
            </figure>
          </div>
        </div>
      </Section>

      <Section bottomMd={80}>
        <div className="container">
          <div className="cs_corporate_qvt">
            <h2 className="cs_fs_32 cs_semibold">
              Un signal fort pour votre politique QVT
            </h2>
            <p className="mb-0">
              Au-delà de son intérêt médical, cette initiative valorise votre
              engagement en faveur de la santé, du bien-être et de la qualité de
              vie au travail de vos collaborateurs.
            </p>
          </div>
        </div>
      </Section>

      <Section id="echanger" className="cs_footer_margin_0" bottomMd={0}>
        <BannerSectionStyle4
          bgUrl="/images/about/banner_bg_2.jpeg"
          title="Parlons de votre entreprise."
          subTitle="Nous serions ravis d’échanger avec vous afin de vous présenter cette démarche et d’étudier ensemble la solution la plus adaptée à votre entreprise."
          center
        />
        <div className="container">
          <div className="cs_corporate_cta_actions">
            <a href="tel:+33156910846" className="cs_btn cs_style_1">
              <span>+33 01 56 91 08 46</span>
              <i>
                <img src="/images/icons/arrow_white.svg" alt="" />
                <img src="/images/icons/arrow_white.svg" alt="" />
              </i>
            </a>
            <a
              href="https://www.doctolib.fr/cabinet-medical/paris/icvt"
              className="cs_btn cs_style_1 cs_btn_white"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>Prendre RDV</span>
              <i>
                <img src="/images/icons/arrow_white.svg" alt="" />
                <img src="/images/icons/arrow_white.svg" alt="" />
              </i>
            </a>
          </div>
        </div>
      </Section>
    </>
  );
}
